// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__18ntg","fileDisabled":"File_fileDisabled__1fBDZ"};